// TIP-609 — the table chrome shared by the real briefs table and the claim
// gate's empty shell: the fixed column proportions and the #F9FBFC heading
// The two differ in their column headings and heading typography (12px #667085
// against 11px uppercase #C2CCD2). That difference is the design's, not a
// mistake of ours, so it is a variant rather than something to harmonise.
import React from "react";
import "./counterpartyBriefs.css";

export const EmptyRow = ({ heading, body, colSpan, gate }) => (
  <tr>
    <td colSpan={colSpan} className={`cb-empty-row${gate ? " cb-empty-row--gate" : ""}`}>
      {heading && <p className="cb-empty-heading">{heading}</p>}
      <p className="cb-empty-body">{body}</p>
    </td>
  </tr>
);

const BriefsTableShell = ({ columns, gate, children }) => (
  <div className="cb-table-scroll">
    <table className={`cb-table${gate ? " cb-table--gate" : ""}`}>
      {/* Widths are proportioned in counterpartyBriefs.css. */}
      <colgroup>
        {columns.map((c) => <col key={c} />)}
      </colgroup>
      <thead>
        <tr>
          {columns.map((c) => <th key={c} className="cb-th">{c}</th>)}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export default BriefsTableShell;
